import { reducer as uiReducer } from 'redux-ui';
import { combineReducers } from 'redux';
import entities from './entities';
import editorUI from './ui';
import bookProperties from './bookproperties';
import backgrounds from './backgrounds';

const editor = combineReducers({
  entities,
  ui: uiReducer,
  editorUI,
  bookProperties,
  backgrounds,
});

export default editor;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js